import EventAvailableIcon from '@material-ui/icons/EventAvailable';

import List from './List';

export default {
  list: List,
  icon: EventAvailableIcon,
};
